import { trim } from './trim.esm.js';

var same = function same(a, b) {
  var _trim, _trim2;
  return ((_trim = trim(a)) === null || _trim === void 0 ? void 0 : _trim.toLowerCase()) === ((_trim2 = trim(b)) === null || _trim2 === void 0 ? void 0 : _trim2.toLowerCase());
};

export { same };
//# sourceMappingURL=same.esm.js.map
